import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { Translate } from "../Translator";
import { IsEmptyString } from "../GeneralFunctions"
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceZendesk = (props) => {

    const CrmServerTokenController = "/api/zendesk/tokens"
    const ClientId = "zdg-cloudcti"
    const Scope = "organizations:read+users:read+tickets:write"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = (props.IntegrationSettings.DatasourceSettings.InstanceUrl ?? "").trim("/") + "/oauth/authorizations/new?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&redirect_uri=" + RedirectUrl

    const [mRepainter, SetRepainter] = useState(false)

    function SetInstanceUrl(aValue)
    {
        props.IntegrationSettings.DatasourceSettings.InstanceUrl = aValue
        SetRepainter(!mRepainter)
    }

    return <div className="scriptitembody">
        <div className="wizardfieldname">{Translate("Domain").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.InstanceUrl || ""} onChange={evt => SetInstanceUrl(evt.target.value)} className="wizardinputfield"/></div>

        {IsEmptyString(props.IntegrationSettings.DatasourceSettings.InstanceUrl) ?
            <Button disabled variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} type="submit">{Translate("Connect")}</Button> :
            <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController={CrmServerTokenController} OnSetReady={props.OnSetReady}/>
        }
    </div>  
}

DatasourceZendesk.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceZendesk